<!-- eslint-disable vue/no-multiple-template-root -->
<template>
  <VitePwaManifest />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <NuxtSnackbar />
</template>
